import type { LimitedSpace } from '@/types'
import type { RecordStrategy, SearchableData } from '../types'

import { ADDITIONAL_REGIONS } from 'src/constants/region'
import { useSpaces } from 'src/store/modules/App/spaces'
import type { SafeAxiosResponse } from '@/services/handleRequest'

export class SpacesRecord implements RecordStrategy {
  async get(): Promise<LimitedSpace[]> {
    const {
      getSpacesFromRegion,
      loadSpaces,
      shouldLoadSpacesFromOtherRegions,
    } = useSpaces()

    const spaces = [...getSpacesFromRegion()]

    if (shouldLoadSpacesFromOtherRegions) {
      ADDITIONAL_REGIONS.forEach((region) => {
        spaces.push(...getSpacesFromRegion(region))
      })
    }

    // if there are no spaces in the store because the page doesn't
    // have a /spaces request, we should load them
    if (!spaces.length) {
      await loadSpaces()
      spaces.push(...getSpacesFromRegion())

      if (shouldLoadSpacesFromOtherRegions) {
        const promises: Promise<
          SafeAxiosResponse<{ spaces: LimitedSpace[] }>
        >[] = []

        ADDITIONAL_REGIONS.forEach((region) => {
          promises.push(loadSpaces(region))
        })

        await Promise.all(promises)

        ADDITIONAL_REGIONS.forEach((region) => {
          spaces.push(...getSpacesFromRegion(region))
        })
      }
    }

    return spaces
  }

  async set(): Promise<void> {
    const spaces = await this.get()

    window?.CommandBar?.addRecords(
      'spaces',
      this.createSearchableRecord(spaces),
    )
  }

  createSearchableRecord(records: LimitedSpace[]): SearchableData[] {
    return records.map((item: LimitedSpace) => ({
      id: item.id,
      title: item.name,
      label: item.name,
    }))
  }
}
